import {Component, Prop, Vue} from "vue-property-decorator";
import VueLightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import {Portal} from "portal-vue";

@Component
class Lightbox extends Vue {

  static mapImages(imageOrImages: string | string[]) {
    if (Array.isArray(imageOrImages)) {
      return imageOrImages.map(img => ({src: img}));
    }
    return [{src: imageOrImages}];
  }

  @Prop({required: true, type: Array}) readonly images: {src: string}[];
  @Prop({default: false, type: Boolean}) readonly showThumbs: boolean;

  proxyCloseEvent(value) {
    if (value === false) {
      this.$emit("close");
    }
  }

  render() {
    return (
      <Portal to="lightbox">
        <VueLightBox {...this.$attrs} images={this.images} showThumbs={this.showThumbs} onOnOpened={this.proxyCloseEvent}/>
      </Portal>
    );
  }
}

export default Lightbox;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-67ad0b59/lightbox.tsx" });